document.addEventListener("DOMContentLoaded", function() {
	$(document).ready(function(){
		if($(".wp-block-wsi-tabs").length > 0){
			$(".wp-block-wsi-tabs").each(function(index, element){
				var el = $(element);
				el.find('.tabs-list').find('.wp-block-wsi-tab').first().addClass('active');
				el.find('.tab-display').html(el.find('.tabs-list').first('.wp-block-wsi-tab').find('.tab-content').html());
				el.find('.tabs-list').find('.wp-block-wsi-tab').each(function(index, elementTab){
					var tab = $(elementTab);
					tab.click(function(e){
						e.preventDefault();
						el.find('.tab-display').html(tab.find('.tab-content').html());
						el.find('.wp-block-wsi-tab').removeClass('active');
						tab.addClass('active');
						$('html, body').animate({
							scrollTop: el.offset().top - 100
						}, 500);
						return false;
					});
				});
			});
		}

		if($(".histories__container").length > 0){
			$(".histories__container").addClass('swiper');
			$(".histories__wrapper").addClass('swiper-wrapper');
			$(".histories__wrapper > .wp-block-wsi-history-item").addClass('swiper-slide');
			$(".histories__container").append(
				$("<div/>")
				.addClass('swiper-navigation swiper-button-container')
				.append(
					$('<button/>')
					.addClass('btn swiper-button-prev')
					.html('<')
				)
				.append(
					$('<button/>')
					.addClass('btn swiper-button-next')
					.html('>')
				)
			);

			const intro = new Swiper('.histories__container', {  
				slidesPerView: 1,
				a11y: {
					enabled: true,
					prevSlideMessage: 'Previous',
					nextSlideMessage: 'Next'
				},
				navigation: {
					nextEl: '.swiper-navigation .swiper-button-next',
					prevEl: '.swiper-navigation .swiper-button-prev',
				},								
			});

			// Get all history items and their first h2
			const items = $(".histories__wrapper > .wp-block-wsi-history-item");
			const timeline = $('<div class="histories-timeline"></div>');

			items.each(function(index) {
				const h2 = $(this).find("h2").first();
				const label = h2.length ? h2.text() : `Item ${index + 1}`;
				const btn = $('<button type="button" class="timeline-btn"></button>')
					.append($('<span></span>').text(label))
					.attr("data-slide", index);
				timeline.append(btn);
			});

			// Insert timeline before the swiper container
			$(".histories__container").before(timeline);

			// Handle timeline button click
			$(".histories-timeline").on("click", ".timeline-btn", function() {
				const slideIndex = $(this).data("slide");
				intro.slideTo(slideIndex);
			});

			// Update active state on slide change
			function updateTimelineActive(idx) {
				$(".histories-timeline .timeline-btn").removeClass("active")
					.eq(idx).addClass("active");
			}
			intro.on('slideChange', function() {
				updateTimelineActive(intro.activeIndex);
			});
			updateTimelineActive(intro.activeIndex);
		}

		if($(".faq__item").length > 0){
			$(".faq__item .read_more_button, .faq__item--content > .wp-block-wsi-faq-title").click(function(e){
				e.preventDefault();
				$(this).parents('.faq__item--content').find('.wp-block-wsi-faq-answer').slideToggle();
				$(this).parents('.faq__item--content').toggleClass('opened');

				return false;
			});
		}
	});	
});
